import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { markAllAsTouched } from '../../../../../utils/markAllAsTouched';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { getCookie } from '../../../../../utils/getCookies';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-license',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, CommonModule, TranslateModule],
  templateUrl: './edit-license.component.html',
  styleUrl: './edit-license.component.scss'
})
export class EditLicenseComponent {

  constructor(public dialogRef: MatDialogRef<EditLicenseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, private http: HttpClient) {
    this.licenseForm = this.fb.group({
      assigned_to_mail: ['', [Validators.required, Validators.email]],
      name_customer: ['', Validators.required]
    });
    }

  licenseForm: FormGroup;
  loading: boolean = false;
  error_message: string = '';
  normal_close: boolean = false;

  ngOnInit(): void {
    this.licenseForm.patchValue(this.data.row);
    this.normal_close = false;
  }

  close(): void {
    this.normal_close = true;
    this.dialogRef.close();
  }

  saveEditLicense() {
    this.error_message = '';
    if (this.licenseForm.valid) {
      this.loading = true;


      const editedLicense = {
        old_mail: this.data.row.assigned_to_mail,
        old_name: this.data.row.name_customer,
        new_mail: this.licenseForm.get('assigned_to_mail')?.value,
        new_name: this.licenseForm.get('name_customer')?.value
      };

      this.http.post(`${environment.url}/api/v1/extension/edit_license`, editedLicense, { headers: { Authorization: `Bearer ${getCookie('access_token')}` } }).subscribe({
        next: (response: any) => {
          console.log('License edited:', response);
          this.dialogRef.close(editedLicense);
        },
        error: (error) => {
          console.error('Error editing license:', error);
          this.loading = false;
          this.error_message = error.error.message;
        }
      });

    } else {
      markAllAsTouched(this.licenseForm);
    }
  }

  deleteLicense() {
    this.error_message = '';
    this.loading = true;
    this.http.post(`${environment.url}/api/v1/extension/remove_access_license`, { email: this.data.row.assigned_to_mail }, { headers: { Authorization: `Bearer ${getCookie('access_token')}` } }).subscribe({
      next: (response: any) => {
        console.log('License deleted:', response);
        response.email = this.data.row.assigned_to_mail;
        this.dialogRef.close(response);
      },
      error: (error) => {
        console.error('Error deleting license:', error);
        this.loading = false;
        this.error_message = error.error.message;
      }
    });
  }
  

  addLicense() {
    this.error_message = '';
    this.loading = true;
    this.http.post(`${environment.url}/api/v1/extension/add_license`, { email: this.licenseForm.get('assigned_to_mail')?.value, name: this.licenseForm.get('name_customer')?.value }, { headers: { Authorization: `Bearer ${getCookie('access_token')}` } }).subscribe({
      next: (response: any) => {
        console.log('License added:', response);
        response.email = this.licenseForm.get('assigned_to_mail')?.value;
        this.dialogRef.close(response);
      },
      error: (error) => {
        console.error('Error adding license:', error);
        this.loading = false;
        this.error_message = error.error.message;
      }
    });
  }

}
